export enum ClientStatus {
  PENDING = 'PENDING',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  BLOCKED = 'BLOCKED',
  WAITING= 'WAITING'
}
